export default __webpack_public_path__ + "b13c135e560c3cd2b2d822d3484d021d.svg";